import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminLogin = () => {
  const [form, setForm]     = useState({ username: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await axios.post(`${API}/adminUser/login`, form);
      localStorage.setItem('adminToken', res.data.token);
      navigate('/adminUser/dashboard');
    } catch {
      setError('Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'monospace',
    }}>
      <div style={{
        background: '#111', border: '1px solid #222',
        borderRadius: 16, padding: 40, width: '100%', maxWidth: 360,
      }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginBottom: 4 }}>
          my<span style={{ color: '#C0392B' }}>linx</span>
        </div>
        <div style={{ fontSize: 12, color: '#555', marginBottom: 32, letterSpacing: 2 }}>
          ADMIN PANEL
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username"
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
            style={{
              width: '100%', padding: '12px 14px', borderRadius: 8,
              border: '1px solid #222', background: '#0a0a0a',
              color: '#fff', fontSize: 14, marginBottom: 12,
              outline: 'none', boxSizing: 'border-box',
            }}
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            style={{
              width: '100%', padding: '12px 14px', borderRadius: 8,
              border: '1px solid #222', background: '#0a0a0a',
              color: '#fff', fontSize: 14, marginBottom: 20,
              outline: 'none', boxSizing: 'border-box',
            }}
          />
          {error && <div style={{ color: '#ef4444', fontSize: 13, marginBottom: 12 }}>{error}</div>}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '12px', borderRadius: 8,
              background: '#C0392B', color: '#fff', border: 'none',
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Logging in...' : 'Login →'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;